
import { useState, useCallback } from "react";
import { getSuggestionsBasedOnContent } from "@/utils/suggestionUtils";
import { Message } from "@/types/message";
import { AssistantData } from "@/types/assistant";

interface UseSuggestionsProps {
  onSendMessage: (message: string) => void;
  messages: Message[];
  assistantData: AssistantData | null;
}

export function useSuggestions({ onSendMessage, messages, assistantData }: UseSuggestionsProps) {
  const [showFollowUpSuggestions, setShowFollowUpSuggestions] = useState<boolean>(true);
  const [showInitialSuggestions, setShowInitialSuggestions] = useState<boolean>(true);

  const handleSuggestionClick = useCallback((question: string) => {
    onSendMessage(question);
    setShowFollowUpSuggestions(false);
  }, [onSendMessage]);

  const handleInitialSuggestionClick = useCallback((question: string) => {
    onSendMessage(question);
    setShowInitialSuggestions(false);
  }, [onSendMessage]);

  // Determine if we should show initial suggestions
  const shouldShowInitialSuggestions = messages.length === 0 && showInitialSuggestions;
  
  // Get suggestions for the last bot message
  const getFollowUpSuggestionsForLastMessage = () => {
    if (messages.length === 0) return [];
    
    // Find the last bot message that isn't an error
    const lastBotMessage = [...messages]
      .reverse()
      .find(msg => msg.isBot && !msg.error);
      
    if (!lastBotMessage) return [];
    
    return getSuggestionsBasedOnContent(lastBotMessage.content);
  };

  const followUpSuggestions = getFollowUpSuggestionsForLastMessage();

  return {
    followUpSuggestions,
    shouldShowInitialSuggestions,
    showFollowUpSuggestions,
    handleSuggestionClick,
    handleInitialSuggestionClick,
  };
}
